import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import './auth/FinestraAccesso.css';
import './AvvisoSessione.css';
import { inAnteprima } from '../../../skin';

/**
 * «LA SESSIONE STA PER SCADERE».
 *
 * Il custode (services/sessione.js) dice QUANDO mostrarlo — quanti secondi
 * prima lo decide la skin dal backoffice — e questa finestra lo mostra, con
 * il conto alla rovescia. Sul telefono sale dal basso come la finestra di
 * accesso, con cui condivide vestito e misure: stesso velo, stessa
 * maniglia, stesso tasto grande vicino al pollice.
 *
 * COSA FA: «Resto collegato» rinnova subito; «Esci adesso» esce. Qualunque
 * tocco sulla pagina conta come attivita' e il custode rinnova da se'.
 * COSA NON FA: non decide i tempi e non tocca la schedina, che resta dov'e'.
 */
function AvvisoSessione({ userService }) {
  const { t } = useTranslation();
  const [avviso, setAvviso] = useState(null);
  const [adesso, setAdesso] = useState(Date.now());
  const [inCorso, setInCorso] = useState(false);

  useEffect(() => {
    if (!userService || typeof userService.avvisoSessione !== 'function') return undefined;
    const sub = userService.avvisoSessione().subscribe((a) => {
      setAvviso(a);
      setInCorso(false);
      setAdesso(Date.now());
    });
    return () => sub.unsubscribe();
  }, [userService]);

  // il conto alla rovescia si aggiorna da solo finche' l'avviso e' in piedi
  useEffect(() => {
    if (!avviso) return undefined;
    const t = setInterval(() => setAdesso(Date.now()), 1000);
    return () => clearInterval(t);
  }, [avviso]);

  if (!avviso) return null;

  const resta = Math.max(0, Math.round((avviso.scadeIl - adesso) / 1000));
  const mm = Math.floor(resta / 60);
  const ss = String(resta % 60).padStart(2, '0');
  const fermo = avviso.fermoDaMinuti || 1;

  const resto = () => {
    if (inCorso) return;
    setInCorso(true);
    if (typeof userService.restoCollegato === 'function') userService.restoCollegato();
  };

  const esci = () => {
    if (typeof userService.doLogout === 'function') userService.doLogout();
  };

  return (
      <div
          className="velo-accesso aperto avviso-sessione"
          role="dialog"
          aria-modal="true"
          aria-labelledby="titolo-avviso-sessione"
          // un tocco fuori dalla finestra e' attivita': si resta collegati
          onMouseDown={(e) => { if (e.target === e.currentTarget) resto(); }}
      >
        <div className="finestra-accesso">
          <span className="maniglia-accesso" aria-hidden="true" />

          <div className="testa-accesso">
            <div>
              <h3 id="titolo-avviso-sessione">
                <span className="punto-avviso" aria-hidden="true" />
                {t('La sessione sta per scadere')}
              </h3>
              <p className="testo-avviso">
                {t('Sei fermo da {{count}} minuti.', { count: fermo })}{' '}
                {/* Il tempo che resta e' in grassetto dentro la frase: <Trans>
                    sa tenere il pezzo marcato al posto giusto in ogni lingua. */}
                <Trans t={t} i18nKey="Fra <grassetto>{{tempo}}</grassetto> verrai scollegato per inattività."
                  values={{ tempo: `${mm}:${ss}` }} components={{ grassetto: <b /> }} />{' '}
                {t('La schedina che stai compilando resta salvata.')}
              </p>
            </div>
          </div>

          <button type="button" className="entra-accesso" onClick={resto} disabled={inCorso}>
            {inCorso ? t('Un attimo…') : t('Resto collegato')}
          </button>

          <button type="button" className="esci-avviso" onClick={esci}>
            {t('Esci adesso')}
          </button>

          {inAnteprima() && <p className="nota-avviso">{t('Quanto si sta fermi prima dell’avviso lo decide la skin dal backoffice.')}</p>}
        </div>
      </div>
  );
}

export default AvvisoSessione;
